import {
  Context,
  createContext
} from '@lit/context';
import { FunIdAuthLogger } from '../funid-auth-logger';

export const funIdAuthLoggerContext: Context<unknown, FunIdAuthLogger> = createContext<FunIdAuthLogger>(Symbol('logger'));
